// src/features/landing/components/VoucherFilters.jsx
"use client";

import RegionSelect from "@/components/RegionSelect";

export default function VoucherFilters({
  filters,
  setFilters,
  filterOptions,
  show = true,
  onReset,
  getCountryName,
  variant = "desktop", // 👈 'desktop' or 'drawer'
}) {
  if (!show) return null;

  const isDrawer = variant === "drawer";
  return (
    <div className={isDrawer ? "" : "hidden lg:block"}>

      {/* The parent <aside> should handle sticky. Keep this panel simple. */}
      <div className="bg-surface text-textPrimary border border-border rounded-xl p-4">
        <div className="flex items-center justify-between mb-3">
          <h2 className="text-sm font-semibold text-textSecondary">Voucher Filters</h2>
        </div>

        {/* Controls */}
        <div className="grid gap-3">
          {/* Category */}
          <div>
            <label className="block text-xs font-medium text-textSecondary mb-1">
              Category
            </label>
            <select
              value={filters.subType}
              onChange={(e) => setFilters((p) => ({ ...p, subType: e.target.value }))}
              className="w-full border border-border rounded-md px-2 py-2 text-sm bg-background text-textPrimary"
            >
              <option value="">All Categories</option>
              {filterOptions.subTypes.map((cat) => (
                <option key={cat} value={cat}>{cat}</option>
              ))}
            </select>
          </div>

          {/* Brand */}
          <div>
            <label className="block text-xs font-medium text-textSecondary mb-1">
              Brand
            </label>
            <select
              value={filters.brand}
              onChange={(e) => setFilters((p) => ({ ...p, brand: e.target.value }))}
              className="w-full border border-border rounded-md px-2 py-2 text-sm bg-background text-textPrimary"
            >
              <option value="">All Brands</option>
              {filterOptions.brands.map((brand) => (
                <option key={brand} value={brand}>{brand}</option>
              ))}
            </select>
          </div>

          {/* Country */}
          <div>
            <label className="block text-xs font-medium text-textSecondary mb-1">
              Country
            </label>
            <select
              value={filters.country}
              onChange={(e) => setFilters((p) => ({ ...p, country: e.target.value }))}
              className="w-full border border-border rounded-md px-2 py-2 text-sm bg-background text-textPrimary"
            >
              <option value="">All Countries</option>
              <option value="GLOBAL">Global</option>
              {filterOptions.countries.map((code) => (
                <option key={code} value={code}>
                  {getCountryName ? getCountryName(code) : code}
                </option>
              ))}
            </select>
          </div>

          {/* Region */}
          <div>
            <RegionSelect
              label="Voucher Region"
              value={filters.regions}
              onChange={(val) => setFilters((p) => ({ ...p, regions: val }))}
              options={[
                { label: "All Regions", value: "" },
                ...filterOptions.regions.map((r) => ({ label: r, value: r })),
              ]}
              dense
            />
          </div>

          {/* Active chips */}
          <div className="pt-1">
            <div className="flex flex-wrap gap-2 text-[11px] text-textSecondary">
              {filters.brand && <span className="bg-background/60 border border-border px-2 py-0.5 rounded">Brand: {filters.brand}</span>}
              {filters.country && <span className="bg-background/60 border border-border px-2 py-0.5 rounded">Country: {getCountryName ? getCountryName(filters.country) : filters.country}</span>}
              {filters.subType && <span className="bg-background/60 border border-border px-2 py-0.5 rounded">Category: {filters.subType}</span>}
              {filters.regions && <span className="bg-background/60 border border-border px-2 py-0.5 rounded">Region: {filters.regions}</span>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
